
import EventItem from '@/components/events/event-item';

export default class EventItemShort extends EventItem {}
